import FormControlLabel, {
  FormControlLabelProps,
} from "@mui/material/FormControlLabel";

export type { FormControlLabelProps };
export default FormControlLabel;
